/* eslint-disable */

import { actions } from 'forms/rrf';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store from '../store';
import ToastMessage from '../components/common/toast-message';

export const getNewContact = () => (dispatch) => {
  dispatch({type: 'NEW_CONTACT_PENDING'});
  return irelandApi.get('/api/contacts/new')
    .then((response) => {
      if (response.data.user) {
        const user = response.data.user;
        const data = {
          title: user.title,
          name: `${user.first_name} ${user.last_name}`,
          outlet_id: '',
          email: user.email,
          telephone: user.mobile,
          message: '',
          type_of_enquiry: ''
        };
        store.dispatch(actions.load('deep.contact_us', data));
      }
      dispatch({type: 'NEW_CONTACT_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'NEW_CONTACT_REJECTED', payLoad: error.data});
    });
};

export const saveContact = payLoad => irelandApi.post('/api/contacts', {contact: payLoad})
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Thanks for your submission"/>);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during contacting us"/>);
    store.dispatch(actions.resetValidity('deep.contact_us'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

